import * as React from 'react'

export const Idea = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.1055 8.27844C24.4012 8.7251 16.5268 16.6054 16.0869 26.31C15.8025 32.5836 18.5734 38.2216 23.037 41.8645C24.8259 43.3245 25.9037 45.48 25.9037 47.7893V52.1534H44.0969V47.7871C44.0969 45.5136 45.1168 43.356 46.8857 41.9278C51.1839 38.4573 53.9335 33.1458 53.9335 27.1912C53.9335 16.4378 44.9689 7.77832 34.1055 8.27844Z"
      fill="#FFD9E6"
    />
    <path
      d="M28.3094 41.8645C23.8458 38.2217 21.075 32.5837 21.3593 26.31C21.7728 17.1928 28.7479 9.68626 37.6375 8.44048C36.4899 8.28052 35.3093 8.22296 34.1055 8.27833C24.4012 8.72499 16.5269 16.6053 16.0869 26.3099C15.8024 32.5835 18.5734 38.2215 23.037 41.8644C24.826 43.3246 25.9037 45.4799 25.9037 47.7892V52.1533H31.1763V47.7892C31.1761 45.4802 30.0985 43.3247 28.3094 41.8645Z"
      fill="#FF92B6"
    />
    <path
      d="M61.1497 28.2315H57.5415C56.9668 28.2315 56.501 27.7656 56.501 27.191C56.501 26.6162 56.9669 26.1504 57.5415 26.1504H61.1497C61.7245 26.1504 62.1903 26.6163 62.1903 27.191C62.1903 27.7656 61.7243 28.2315 61.1497 28.2315Z"
      fill="#F95986"
    />
    <path
      d="M12.4584 28.2315H8.85014C8.27537 28.2315 7.80957 27.7656 7.80957 27.191C7.80957 26.6162 8.27551 26.1504 8.85014 26.1504H12.4583C13.033 26.1504 13.4988 26.6163 13.4988 27.191C13.499 27.7656 13.033 28.2315 12.4584 28.2315Z"
      fill="#F95986"
    />
    <path
      d="M50.2033 11.986C49.7968 11.5797 49.7968 10.9207 50.2033 10.5144L52.7547 7.96295C53.1611 7.55662 53.82 7.55662 54.2264 7.96295C54.6328 8.36928 54.6328 9.02826 54.2264 9.43459L51.6749 11.986C51.2686 12.3925 50.6098 12.3924 50.2033 11.986Z"
      fill="#F95986"
    />
    <path
      d="M15.7736 46.4177C15.3671 46.0113 15.3671 45.3525 15.7736 44.946L18.325 42.3946C18.7314 41.9883 19.3904 41.9883 19.7967 42.3946C20.2031 42.8009 20.2031 43.4598 19.7967 43.8662L17.2452 46.4177C16.8388 46.8241 16.1799 46.824 15.7736 46.4177Z"
      fill="#F95986"
    />
    <path
      d="M35 5.68941C34.4253 5.68941 33.9595 5.22348 33.9595 4.64885V1.04057C33.9595 0.465937 34.4254 0 35 0C35.5747 0 36.0406 0.465937 36.0406 1.04057V4.64871C36.0407 5.22361 35.5748 5.68941 35 5.68941Z"
      fill="#F95986"
    />
    <path
      d="M18.3246 11.986L15.7731 9.43459C15.3666 9.02826 15.3666 8.36928 15.7731 7.96295C16.1794 7.55662 16.8384 7.55662 17.2447 7.96295L19.7962 10.5144C20.2027 10.9207 20.2027 11.5797 19.7962 11.986C19.3899 12.3925 18.731 12.3924 18.3246 11.986Z"
      fill="#F95986"
    />
    <path
      d="M52.7547 46.4178L50.2033 43.8663C49.7968 43.4599 49.7968 42.801 50.2033 42.3947C50.6096 41.9882 51.2686 41.9882 51.6749 42.3947L54.2264 44.9461C54.6328 45.3526 54.6328 46.0114 54.2264 46.4178C53.82 46.8241 53.1611 46.8242 52.7547 46.4178Z"
      fill="#F95986"
    />
    <path
      d="M35.3106 36.773C34.9963 36.2919 35.1317 35.647 35.6128 35.3327L38.1798 33.656C38.1923 33.6479 38.2047 33.6401 38.2174 33.6326C38.4761 33.479 38.6367 33.1967 38.6367 32.8959V28.2359C38.6367 27.6611 39.1027 27.1953 39.6773 27.1953C40.2519 27.1953 40.718 27.6612 40.718 28.2359V32.8959C40.718 33.9191 40.1759 34.8797 39.3014 35.4094L36.751 37.0753C36.2697 37.3895 35.6249 37.2541 35.3106 36.773Z"
      fill="#EC6491"
    />
    <path
      d="M33.4413 37.0912L30.7124 35.4179C29.8297 34.8901 29.2817 33.9246 29.2817 32.8959V28.2359C29.2817 27.6611 29.7477 27.1953 30.3223 27.1953C30.8971 27.1953 31.3629 27.6613 31.3629 28.2359V32.8959C31.3629 33.1967 31.5235 33.479 31.7822 33.6326C31.7864 33.635 31.7905 33.6376 31.7946 33.6401L34.529 35.3168C35.019 35.6172 35.1727 36.258 34.8722 36.7479C34.5718 37.2383 33.9307 37.3914 33.4413 37.0912Z"
      fill="#EC6491"
    />
    <path
      d="M41.2022 31.0382H28.7598C28.185 31.0382 27.7192 30.5722 27.7192 29.9976C27.7192 29.4228 28.1852 28.957 28.7598 28.957H41.2022C41.7769 28.957 42.2427 29.423 42.2427 29.9976C42.2429 30.5722 41.7769 31.0382 41.2022 31.0382Z"
      fill="#EC6491"
    />
    <path
      d="M37.8721 42.8504C37.4275 42.5959 37.1592 42.1171 37.1592 41.6049V36.3572C37.1592 35.6184 36.5602 35.0195 35.8215 35.0195H34.1781C33.4393 35.0195 32.8405 35.6185 32.8405 36.3572V41.6049C32.8405 42.1171 32.5721 42.5959 32.1275 42.8504C31.3493 43.2958 30.8247 44.1332 30.8247 45.0943V52.1527H39.1751V45.0943C39.1749 44.1333 38.6504 43.2958 37.8721 42.8504Z"
      fill="#EC6491"
    />
    <path
      d="M36.4694 42.8505C36.8619 42.6259 37.1164 42.2263 37.1708 41.7831C37.1635 41.7244 37.1592 41.6649 37.1592 41.6049V36.3572C37.1592 35.6184 36.5602 35.0195 35.8215 35.0195H34.1781C33.4393 35.0195 32.8405 35.6185 32.8405 36.3572V41.6049C32.8405 42.1171 32.5721 42.5959 32.1275 42.8504C31.3493 43.2958 30.8247 44.1332 30.8247 45.0943V52.1527H35.1666V45.0943C35.1666 44.1335 35.6912 43.2959 36.4694 42.8505Z"
      fill="#EC6491"
    />
    <path
      d="M35 53.1933C34.4253 53.1933 33.9595 52.7274 33.9595 52.1528V45.9605C33.9595 45.3857 34.4254 44.9199 35 44.9199C35.5747 44.9199 36.0406 45.3859 36.0406 45.9605V52.1528C36.0407 52.7274 35.5748 53.1933 35 53.1933Z"
      fill="#FFEAF1"
    />
    <path
      d="M28.54 64.5547C29.135 67.5799 31.8006 70.0009 35.0001 70.0009C38.1996 70.0009 40.8652 67.5799 41.4602 64.5548H28.54V64.5547Z"
      fill="#B63962"
    />
    <path
      d="M33.6276 64.5547H28.54C29.135 67.5799 31.8006 70.0009 35.0001 70.0009C35.9019 70.0009 36.7613 69.8084 37.5439 69.4644C35.55 68.588 34.0549 66.7271 33.6276 64.5547Z"
      fill="#8F1B42"
    />
    <path
      d="M41.9306 60.2344H28.0691C27.3303 60.2344 26.7314 60.8333 26.7314 61.572V63.3542C26.7314 64.093 27.3304 64.6918 28.0691 64.6918H41.9306C42.6694 64.6918 43.2683 64.0928 43.2683 63.3542V61.572C43.2684 60.8333 42.6694 60.2344 41.9306 60.2344Z"
      fill="#D54C79"
    />
    <path
      d="M31.819 63.3542V61.572C31.819 60.8332 32.418 60.2344 33.1567 60.2344H28.0691C27.3303 60.2344 26.7314 60.8333 26.7314 61.572V63.3542C26.7314 64.093 27.3304 64.6918 28.0691 64.6918H33.1567C32.4179 64.6918 31.819 64.093 31.819 63.3542Z"
      fill="#AA2C56"
    />
    <path
      d="M44.7898 55.916H25.2097C24.4709 55.916 23.8721 56.515 23.8721 57.2537V59.0358C23.8721 59.7746 24.471 60.3735 25.2097 60.3735H44.7898C45.5286 60.3735 46.1274 59.7745 46.1274 59.0358V57.2537C46.1274 56.5148 45.5286 55.916 44.7898 55.916Z"
      fill="#DF5784"
    />
    <path
      d="M28.9596 59.0358V57.2537C28.9596 56.5148 29.5586 55.916 30.2973 55.916H25.2097C24.4709 55.916 23.8721 56.515 23.8721 57.2537V59.0358C23.8721 59.7746 24.471 60.3735 25.2097 60.3735H30.2973C29.5585 60.3735 28.9596 59.7745 28.9596 59.0358Z"
      fill="#BB3360"
    />
    <path
      d="M44.7898 51.7363H25.2097C24.4709 51.7363 23.8721 52.3353 23.8721 53.074V54.7173C23.8721 55.4562 24.471 56.055 25.2097 56.055H44.7896C45.5285 56.055 46.1273 55.456 46.1273 54.7173V53.074C46.1274 52.3353 45.5285 51.7363 44.7898 51.7363Z"
      fill="#FFF1F6"
    />
    <path
      d="M28.9596 54.7172V53.074C28.9596 52.3352 29.5586 51.7363 30.2973 51.7363H25.2097C24.4709 51.7363 23.8721 52.3353 23.8721 53.074V54.7173C23.8721 55.4562 24.471 56.055 25.2097 56.055H30.2973C29.5585 56.055 28.9596 55.456 28.9596 54.7172Z"
      fill="#FFDCE8"
    />
  </svg>
)
